import { withStateHandlers, withHandlers, compose } from 'recompose'
import { reduxForm } from 'redux-form'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { FILTER_MODAL, FILTER_MODAL_FORM } from 'constant'
import {
  updateFilter,
  disableFilter,
  toggleFilter,
  removeSelectedFilter
} from './helpers'
import FilterModal from './FilterModal'

const createInitialState = ({ data = []}) => ({
  filters: data,
  selectedFilters: data.reduce((acc, { refinements }) => ([
    ...acc,
    ...refinements.filter(({ selected }) => selected)
  ]), [])
})

const withFilterState = withStateHandlers(createInitialState, {
  handleFilterRemove: ({ filters, selectedFilters, ...state }) => selectedFilter => ({
    ...state,
    selectedFilters: removeSelectedFilter(selectedFilters, selectedFilter),
    filters: updateFilter(filters, selectedFilter, disableFilter)
  }),
  handleFilterToggle: ({ filters, selectedFilters, ...state }) => toggledFilter => {
    const { selected } = toggledFilter

    return {
      ...state,
      filters: updateFilter(filters, toggledFilter, toggleFilter),
      selectedFilters: selected ?
        removeSelectedFilter(selectedFilters, toggledFilter) :
        [...selectedFilters, toggledFilter]
    }
  },
  handleFilterClear: ({ filters, selectedFilters, ...state }) => () => ({
    ...state,
    selectedFilters: [],
    filters: selectedFilters.reduce(
      (filters, filter) => updateFilter(filters, filter, disableFilter),
      filters
    )
  })
})

const withFilterUpdate = withHandlers({
  handleUpdate: ({ selectedFilters, onFiltersUpdate }) => () =>
    onFiltersUpdate({ selectedFilters })
})

export const Modal = compose(
  withFilterState,
  withFilterUpdate
)(FilterModal)

export default compose(
  registerReduxModal({ name: FILTER_MODAL }),
  reduxForm({ form: FILTER_MODAL_FORM })
)(Modal)
